import { type CardIdType, type CardMapType } from '@/defs/card'
import { type PriceSourceType } from '@/defs/price'

import styles from './ClipboardBuyLinks.module.scss'
import { ClipboardBuyLinksButton } from './ClipboardBuyLinksButton/ClipboardBuyLinksButton'

type Props = {
  cardIds: CardIdType[]
  cardMap: CardMapType
  decklist: string[]
}

export const ClipboardBuyLinks = ({ cardIds, cardMap, decklist }: Props) => {
  const priceSources: PriceSourceType[] = ['cardkingdom', 'tcgplayer', 'manapool', 'scg', 'cardsphere']

  return (
    <ul className={styles.container}>
      {priceSources.map((priceSource) => (
        <ClipboardBuyLinksButton
          cardIds={cardIds}
          cardMap={cardMap}
          decklist={decklist}
          key={priceSource}
          priceSource={priceSource}
        />
      ))}
    </ul>
  )
}
